import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_3 = { class: "mt-0 lg:mt-4 flex items-baseline text-gray-900" }
const _hoisted_4 = { class: "text-5xl font-extrabold tracking-tight" }
const _hoisted_5 = {
  role: "list",
  class: "mt-0 lg:mt-4 mb-2 space-y-6"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = ["href"]

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '../../services/utilityServiceInterface';

import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VoipSelectorProductOld',
  props: {
    isSelectedProduct: { type: Boolean },
    product: {}
  },
  emits: ["handle-select-product"],
  setup(__props: any, { emit: __emit }) {

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



const emit = __emit;

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const standardLinks: Array<{ name: string, link: string }> = [{
  name: 'Critical Information Summary',
  link: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${brandService.getName()}/critical-information-summary-phone.pdf`
}];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectProduct(_ctx.product))),
    class: _normalizeClass(["my-2 lg:my-0 cursor-pointer transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col border border-solid font-gotham-medium", [_ctx.isSelectedProduct ? 'border-black' : 'border-gray-200']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, "Talk " + _toDisplayString(_unref(utilityService).toTitleCase(_ctx.product.name)), 1),
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "$" + _toDisplayString(_ctx.product.price), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-1 text-xl font-semibold text-gray-900" }, "/Month", -1))
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.product.description), 1)
        ])
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(standardLinks, (standardLink) => {
        return _createElementVNode("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href text-blue-500 hover:text-blue-800 hover:underline transition duration-250 my-3"
        }, _toDisplayString(standardLink.name), 9, _hoisted_8)
      }), 64))
    ]),
    _createElementVNode("button", {
      class: _normalizeClass([('mt-0 lg:mt-3 block w-full py-3 px-6 border border-transparent rounded-md text-center font-gotham-medium '), (_ctx.isSelectedProduct ? 'bg-brand-primary text-white' : 'bg-brand-primary-light hover:bg-brand-primary text-brand-secondary')])
    }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Product'), 3)
  ], 2))
}
}

})